import useContact from './useContact';

const useContactName = (contactID, fallback = '') => {
  const { data: contact, isLoading, isError } = useContact(contactID);

  let fullName = fallback;
  if (!isLoading && !isError && contact) {
    const trimmedFirstName = contact.firstName ? contact.firstName.trim() : '';
    const trimmedLastName = contact.lastName ? contact.lastName.trim() : '';
    fullName = `${trimmedFirstName} ${trimmedLastName}`;
  }

  return { fullName, isLoading, isError };
};

export default useContactName;
